/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTransactionDelete } from '../fn/transaction/api-transaction-delete';
import { ApiTransactionDelete$Params } from '../fn/transaction/api-transaction-delete';
import { apiTransactionGet } from '../fn/transaction/api-transaction-get';
import { ApiTransactionGet$Params } from '../fn/transaction/api-transaction-get';
import { apiTransactionPost } from '../fn/transaction/api-transaction-post';
import { ApiTransactionPost$Params } from '../fn/transaction/api-transaction-post';
import { apiTransactionYearGet } from '../fn/transaction/api-transaction-year-get';
import { ApiTransactionYearGet$Params } from '../fn/transaction/api-transaction-year-get';
import { NotificationMessage } from '../models/notification-message';
import { TransactionReportingWrapper } from '../models/transaction-reporting-wrapper';

@Injectable({ providedIn: 'root' })
export class TransactionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTransactionGet()` */
  static readonly ApiTransactionGetPath = '/api/transaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTransactionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactionGet$Response(params?: ApiTransactionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    return apiTransactionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTransactionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactionGet(params?: ApiTransactionGet$Params, context?: HttpContext): Observable<Array<number>> {
    return this.apiTransactionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `apiTransactionPost()` */
  static readonly ApiTransactionPostPath = '/api/transaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTransactionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTransactionPost$Response(params?: ApiTransactionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiTransactionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTransactionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTransactionPost(params?: ApiTransactionPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiTransactionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiTransactionDelete()` */
  static readonly ApiTransactionDeletePath = '/api/transaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTransactionDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactionDelete$Response(params?: ApiTransactionDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiTransactionDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTransactionDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactionDelete(params?: ApiTransactionDelete$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiTransactionDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiTransactionYearGet()` */
  static readonly ApiTransactionYearGetPath = '/api/transaction/{year}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTransactionYearGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactionYearGet$Response(params: ApiTransactionYearGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionReportingWrapper>> {
    return apiTransactionYearGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTransactionYearGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactionYearGet(params: ApiTransactionYearGet$Params, context?: HttpContext): Observable<TransactionReportingWrapper> {
    return this.apiTransactionYearGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionReportingWrapper>): TransactionReportingWrapper => r.body)
    );
  }

}
